module.exports = __webpack_public_path__ + "static/media/service_application_bg.d55056ab.png";